<template>
  <div class="modal" :id="loadingID" tabindex="-1" role="dialog" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="row justify-content-between">
            <div class="col-auto h2">
              {{ loadingTitle }}
            </div>
          </div>
          <div class="progress">
            <div class="progress-bar progress-bar-info progress-bar-striped active" style="width:100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseLoadingPopUp",
  /** mixins **/
  mixins: [],

  /** props **/
  props: {
    loadingTitle: String,
    loadingID: String
  },

  /** data **/
  data() {
    return {
      percentage: 0
    };
  },

  /** components **/
  components: {},

  /** methods **/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {},

  /** created **/
  created() {
    const interval = setInterval(() => {
      if (this.percentage < 97)
        this.percentage += .1
      else {
        clearInterval(interval)
      }
    }, 15)
  },

  /** watch
   searchText : {
    handler : 'fetchUserList',
    immediate : true,
  }
   **/
  watch: {},

  /** destroyed **/
  destroyed() {},
}
</script>

<style scoped lang="scss">
  /* progress modal css */
  .progress{
    height: 30px;
    background: #fff;
    border-top: 5px solid #d44946;
    border-bottom: 5px solid #d44946;
    overflow: visible;
    position: relative;
  }
  .progress:before,
  .progress:after{
    content: "";
    width: 5px;
    background: #d44946;
    position: absolute;
    top: 0;
    left: -5px;
    bottom: 0;
  }
  .progress:after{
    left: auto;
    right: -5px;
  }
  .progress .progress-bar{
    border: none;
    box-shadow: none;
    background-color: #d44946;
    -webkit-animation: 12s linear 0s normal none infinite running progress-bar-stripes,animate-positive 8s;
    animation: 12s linear 0s normal none infinite running progress-bar-stripes,animate-positive 8s;
  }
  @-webkit-keyframes animate-positive{
    0%{ width: 0; }
    50%{ width: 50%; }
    75%{ width: 75%; }
    100%{ width: 95%; }
  }
  @keyframes animate-positive{
    0%{ width: 0; }
    50%{ width: 50%; }
    75%{ width: 75%; }
    100%{ width: 95%; }
  }
</style>